export const getIsEvo = (baseUrl: string): boolean => {
  return (baseUrl || "").includes("evo");
};
